import axios from '@/api/index.js'
const state = {
  token: '',
  roles: [],
  userName: '',
  name: ''

}
const mutations = {
  setToken(state, payload) {
    state.token = payload
  },
  setRoles(state, payload) {
    state.roles = payload
  },
  setUserName(state, payload) {
    state.userName = payload
  },
  setName(state, payload) {
    state.name = payload
  },
  logout(state, payload) {
    state.name = ""
    state.userName = ""
    state.roles = []
  }
}
const actions = {
  login({ commit, dispatch }, loginInfo) {
    return new Promise(async (resolve, reject) => {
      axios.post('auth/login', loginInfo).then(res => {
        if (res.status === 200) {
          let accessToken = res.data.tokenType + " " + res.data.accessToken
          commit('setToken', accessToken)
          resolve(accessToken)
        }
      }).catch(err => {
        reject(err.response)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}